<template>
  <v-select :label="label" v-model="value" :items="items" :rules="validationRules" :disabled="disabled" filled />
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'LeanEnum',
  mixins: [fieldMixin],
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    items: {
      get() {
        return this.config.options || [];
      }
    }
  }
};
</script>
